// extracted by mini-css-extract-plugin
export default {"container":"Plans_container__TUtBn","plansImg":"Plans_plansImg__S6WYP","info":"Plans_info__7ctm0","numb":"Plans_numb__D-t4E","title":"Plans_title__YcOYQ"};